import { CONFIG } from './config.js';
import { escapa, linkWhatsapp } from './cartao.js';
import {
  preco, faixaQuartos, faixaArea, entrega,
  rotuloConstrutora, rotuloDiferencial, comoLista,
} from './formato.js';

const cache = new Map();

const item = (rotulo, valor) =>
  (valor
    ? `<div class="ficha-item"><span>${escapa(rotulo)}</span><strong>${escapa(valor)}</strong></div>`
    : '');

export function montaHtmlPainel(d) {
  const fotos = comoLista(d.fotos).slice(0, 30);
  const slides = fotos
    .map((f, i) => `<img src="${escapa(f)}" loading="${i === 0 ? 'eager' : 'lazy'}"
        decoding="async" alt="Foto ${i + 1} de ${escapa(d.titulo)}">`)
    .join('');

  const ficha = [
    ['Quartos', faixaQuartos(d.quartosMin, d.quartosMax)],
    ['Área', faixaArea(d.areaMin, d.areaMax)],
    ['Suítes', d.suites ? String(d.suites) : null],
    ['Banheiros', d.banheiros ? String(d.banheiros) : null],
    ['Vagas', d.vagas ? String(d.vagas) : null],
    ['Entrega', entrega(d.entrega)],
    ['Construtora', rotuloConstrutora(d.construtora)],
  ].map(([k, v]) => item(k, v)).join('');

  const dif = comoLista(d.diferenciais)
    .map((x) => `<li>${escapa(rotuloDiferencial(x))}</li>`)
    .join('');

  return `
  <button id="fechar-painel" type="button" aria-label="Fechar detalhes">✕</button>
  ${fotos.length ? `<div class="painel-galeria">${slides}</div>` : ''}
  <div class="painel-corpo">
    ${d.status ? `<span class="cartao-selo">${escapa(d.status)}</span>` : ''}
    <h2>${escapa(d.titulo)}</h2>
    <p class="cartao-local">${escapa([d.bairro, d.cidade].filter(Boolean).join(' · '))}</p>
    ${d.endereco ? `<p class="painel-endereco">${escapa(d.endereco)}</p>` : ''}
    <p class="cartao-preco">${escapa(preco(d.precoMin))}<small>a partir de</small></p>
    <div class="cartao-ficha">${ficha}</div>
    ${d.descricao ? `<p class="painel-descricao">${escapa(d.descricao)}</p>` : ''}
    ${dif ? `<h3 class="painel-sub">Lazer e diferenciais</h3><ul class="cartao-dif">${dif}</ul>` : ''}
    ${d.precisao === 'bairro'
      ? '<p class="cartao-aviso">Localização aproximada — posição do bairro</p>' : ''}
  </div>
  <div class="painel-acoes">
    <a class="botao primario" href="${escapa(linkWhatsapp(d))}" target="_blank" rel="noopener"
       data-evento="whatsapp_clique" data-id="${escapa(d.id)}">Falar no WhatsApp</a>
    <a class="botao secundario" href="${escapa(d.url)}" target="_blank" rel="noopener"
       data-evento="site_clique" data-id="${escapa(d.id)}">Ver no site</a>
  </div>`;
}

export function criaPainel(elemento, deps = {}) {
  const { buscaFn = fetch } = deps;
  let focoAnterior = null;

  function fecha() {
    elemento.hidden = true;
    elemento.innerHTML = '';
    if (focoAnterior) { focoAnterior.focus(); focoAnterior = null; }
  }

  async function abre(slug) {
    focoAnterior = document.activeElement;
    elemento.hidden = false;
    elemento.innerHTML = '<p class="painel-carregando">Carregando…</p>';

    let dados = cache.get(slug);
    if (!dados) {
      try {
        const r = await buscaFn(CONFIG.detalhe(slug));
        if (!r.ok) throw new Error(String(r.status));
        dados = await r.json();
        cache.set(slug, dados);
      } catch {
        elemento.innerHTML =
          '<p class="painel-carregando">Não foi possível carregar os detalhes.</p>';
        return;
      }
    }
    elemento.innerHTML = montaHtmlPainel(dados);
    elemento.querySelector('#fechar-painel').addEventListener('click', fecha);
    elemento.focus();
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !elemento.hidden) fecha();
  });

  // Enquanto o painel está aberto, Tab não deve escapar para o mapa atrás.
  elemento.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab' || elemento.hidden) return;
    const focaveis = elemento.querySelectorAll('a[href], button, [tabindex="0"]');
    if (focaveis.length === 0) return;
    const primeiro = focaveis[0];
    const ultimo = focaveis[focaveis.length - 1];
    if (e.shiftKey && document.activeElement === primeiro) {
      e.preventDefault(); ultimo.focus();
    } else if (!e.shiftKey && document.activeElement === ultimo) {
      e.preventDefault(); primeiro.focus();
    }
  });

  return { abre, fecha };
}
